<script setup lang="ts">
import {BlockProps} from "@/utils/presenters/interfaces.ts";
import {computed, watchEffect} from "vue";
import DashboardPresenter from "@/utils/presenters/DashboardPresenter.ts";
import Dashboard from "@/views/Dashboard.vue";
import {storeToRefs} from "pinia";
import {useNamaFlagsStore} from "@/stores/nama-flags-store.ts";
import GUIUtilities from "@/utils/common/GUIUtilities.ts";
import Translator from "@/utils/common/Translator.ts";
import EmbeddedViewUtils from "@/utils/editView/editScreens/EmbeddedViewUtils.ts";
import EditScreenDashBoard = namaTypes.EditScreenDashBoard;
import DTOAbstractParamsMapping = namaTypes.DTOAbstractParamsMapping;

const props = defineProps<BlockProps>();
const blockRef = computed<EditScreenDashBoard>(() => props.block as EditScreenDashBoard);
const {darkMode} = storeToRefs(useNamaFlagsStore());
const calculatedHeight = computed(() => {
  if (blockRef.value && blockRef.value.size)
    return GUIUtilities.gridSizeToPixels(blockRef.value.size) ?? 300;
});
let dashboardPresenter: DashboardPresenter = new DashboardPresenter();

async function start() {
  dashboardPresenter.searchContextProvider = props.presenter.fetchDispatcher();
  dashboardPresenter.parametersMapping = blockRef.value.reportInfo as DTOAbstractParamsMapping;
  dashboardPresenter.dashboardId = blockRef.value.reportInfo?.reportId;
  const defaultValues = EmbeddedViewUtils.createQuestionFromMapping(dashboardPresenter.searchContextProvider, dashboardPresenter.parametersMapping);
  //any effects after the following statement will not be watched, because an await is used
  await dashboardPresenter.questionFieldsPresenter.edit(dashboardPresenter.metadata?.questionFields, defaultValues);
  await dashboardPresenter.fetchCharts(dashboardPresenter.dashboardId);
}

watchEffect(async () => {
  if (props.collapsed)
    return;
  await start();
});
</script>

<template>
  <div :style="'height:'+calculatedHeight+'px'">
    <q-card class="tw-h-full tw-w-full tw-flex tw-flex-col tw-shadow-none tw-bg-transparent tw-p-0">
      <div class="tw-grow">
        <q-scroll-area :dark="darkMode" class="tw-h-full tw-w-full dir-ltr">
          <template v-if="dashboardPresenter.displayDashboard.value">
            <Dashboard :dir="Translator.fetchDir()" :presenter="dashboardPresenter" isEditScreen/>
          </template>
        </q-scroll-area>
      </div>
    </q-card>
  </div>
</template>
